"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectModelInstance = exports.ProjectModelSchema = exports.ProjectModelAssetSchema = exports.AssetMimeTypeSchema = exports.ProjectModelAssetTypeSchema = exports.ProjectModelAssetType = void 0;
const Layer_1 = require("./DrawingModels/Layer");
const component_1 = require("./component");
const pcb_1 = require("./pcb");
const SchematicModel_1 = require("./SchematicModel");
const MessageResult_1 = require("../MessageResult");
const ProjectFontConfiguration_1 = require("./ProjectFontConfiguration");
const ProjectModule_1 = require("./ProjectModule");
const CadTool_1 = require("./CadTool");
const ProjectDataTypeInstance_1 = require("./ProjectInstances/ProjectDataTypeInstance");
const metadata_1 = require("./metadata");
const zod_1 = require("zod");
const GlobalNetInfo_1 = require("./GlobalNetInfo");
const DesignHierarchy_1 = require("./DesignHierarchy");
const Image_1 = require("./DrawingModels/Image");
var ProjectModelAssetType;
(function (ProjectModelAssetType) {
    ProjectModelAssetType["Image"] = "image";
    ProjectModelAssetType["Design"] = "design";
    ProjectModelAssetType["ComponentDefinition"] = "cpdef";
    ProjectModelAssetType["ProcessingResults"] = "procres";
})(ProjectModelAssetType || (exports.ProjectModelAssetType = ProjectModelAssetType = {}));
exports.ProjectModelAssetTypeSchema = zod_1.default.nativeEnum(ProjectModelAssetType);
exports.AssetMimeTypeSchema = zod_1.default.union([Image_1.ImageMimeTypeSchema, zod_1.default.literal('application/json')]);
exports.ProjectModelAssetSchema = zod_1.default.object({
    type: exports.ProjectModelAssetTypeSchema,
    ref: zod_1.default.string(),
    name: zod_1.default.string(),
    mimeType: exports.AssetMimeTypeSchema,
});
exports.ProjectModelSchema = zod_1.default.object({
    modelVersion: zod_1.default.string().optional(),
    type: CadTool_1.CadToolSchema,
    name: zod_1.default.string().optional(),
    layerSets: zod_1.default.record(zod_1.default.string(), zod_1.default.array(Layer_1.LayerSchema)),
    designs: zod_1.default.record(zod_1.default.string(), zod_1.default.discriminatedUnion('modelType', [pcb_1.PcbModelSchema, SchematicModel_1.SchematicModelSchema])),
    components: zod_1.default.record(zod_1.default.string(), component_1.ComponentSchema),
    modules: ProjectModule_1.ProjectModuleSchema.array(),
    warnings: zod_1.default.string().array(),
    processingResults: (0, MessageResult_1.AggregateMessageResultSchema)(zod_1.default.literal('project-processing'), MessageResult_1.MessageResultSchemaDefault).prefault({
        type: 'project-processing',
        message: '',
        innerResults: [],
    }),
    fonts: ProjectFontConfiguration_1.ProjectFontConfigurationSchema.optional(),
    globalNets: zod_1.default.record(zod_1.default.string(), GlobalNetInfo_1.GlobalNetInfoSchema),
    metadata: metadata_1.MetadataSchema.optional(),
    designHierarchy: DesignHierarchy_1.DesignHierarchyNodeSchema.array().optional(),
    assets: exports.ProjectModelAssetSchema.array().optional(),
});
class ProjectModelInstance extends ProjectDataTypeInstance_1.ProjectDataTypeInstance {
    constructor(context, opts) {
        super(context);
        this.layerSets = {};
        this.designs = {};
        this.components = {};
        this.modules = [];
        this.warnings = [];
        this.processingResults = {
            type: 'project-processing',
            message: '',
            innerResults: [],
        };
    }
    getGlobalNetsObject() {
        return Object.fromEntries(this.globalNets.map((n) => [n.name, n.toJSON()]));
    }
    toJSON() {
        return {
            type: this.type,
            name: this.name,
            layerSets: this.layerSets,
            designs: this.designs,
            components: this.components,
            modules: this.modules,
            warnings: this.warnings,
            processingResults: this.processingResults,
            fonts: this.fonts,
            globalNets: this.getGlobalNetsObject(),
        };
    }
}
exports.ProjectModelInstance = ProjectModelInstance;
//# sourceMappingURL=ProjectModel.js.map